export const siteConfig = {
  name: '91short',
  fullName: '91short短视频平台',
  tagline: '发现精彩短视频，记录生活每一刻',
  description: '91short是专注于短视频内容创作与分享的平台，汇聚海量优质短视频资源。轻松创作、上传和分享你的精彩瞬间。',
  url: 'https://www.91short.com',
  downloadUrl: '#download',
};

export const navLinks = [
  { label: '首页', href: '/' },
  { label: '热门分类', href: '/category/trending' },
  { label: '创作者', href: '/about' },
  { label: '关于我们', href: '/about' },
];

export const statsData = [
  { icon: 'ri-user-smile-line', value: '5000万+', label: '活跃用户' },
  { icon: 'ri-vidicon-line', value: '10亿+', label: '短视频资源' },
  { icon: 'ri-star-line', value: '200万+', label: '优质创作者' },
  { icon: 'ri-download-2-line', value: '8000万+', label: '累计下载' },
];

export const featuresData = [
  {
    icon: 'ri-sparkling-line',
    title: '智能推荐算法',
    description: '基于AI的个性化推荐系统，精准匹配你的兴趣偏好，让你总能发现喜欢的精彩内容。',
  },
  {
    icon: 'ri-edit-2-line',
    title: '强大创作工具',
    description: '内置丰富的视频编辑功能，滤镜、特效、音乐、字幕一键添加，让创作变得简单有趣。',
  },
  {
    icon: 'ri-share-forward-line',
    title: '一键多平台分享',
    description: '创作完成后可一键分享至微信、微博、QQ等主流社交平台，让更多人看到你的作品。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全内容审核',
    description: '智能+人工双重审核机制，确保平台内容健康安全，营造绿色积极的社区氛围。',
  },
];

export const creatorShowcase = [
  {
    name: '小雨同学',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20female%20portrait%20with%20warm%20lighting%2C%20fashionable%20casual%20style%2C%20clean%20studio%20background%20with%20soft%20pastel%20tones%2C%20professional%20headshot%20photography%20with%20natural%20skin%20texture%2C%20friendly%20smile%2C%20minimalist%20aesthetic&width=200&height=200&seq=creator-avatar-01&orientation=squarish',
    followers: '320万',
    category: '生活记录',
    description: '用镜头捕捉生活中的美好瞬间，分享温暖治愈的日常故事。',
  },
  {
    name: '潮流阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20male%20street%20style%20portrait%2C%20trendy%20urban%20fashion%2C%20cool%20expression%2C%20clean%20minimalist%20background%20with%20warm%20lighting%2C%20editorial%20portrait%20photography%2C%20modern%20aesthetic%2C%20confident%20look&width=200&height=200&seq=creator-avatar-02&orientation=squarish',
    followers: '580万',
    category: '潮流穿搭',
    description: '带你探索最新潮流趋势，分享穿搭灵感和时尚生活方式。',
  },
  {
    name: '美食达人Linda',
    avatar: 'https://readdy.ai/api/search-image?query=Asian%20female%20portrait%20with%20warm%20smile%2C%20kitchen%20background%20with%20soft%20natural%20light%2C%20casual%20elegant%20style%2C%20food%20blogger%20aesthetic%2C%20professional%20headshot%2C%20clean%20and%20warm%20tone&width=200&height=200&seq=creator-avatar-03&orientation=squarish',
    followers: '410万',
    category: '美食探店',
    description: '走遍大街小巷，寻味地道美食，用短视频记录舌尖上的中国。',
  },
  {
    name: '科技小新',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20male%20portrait%2C%20tech%20enthusiast%20style%2C%20minimalist%20studio%20background%2C%20modern%20aesthetic%2C%20clean%20lighting%2C%20professional%20headshot%20photography%2C%20friendly%20expression&width=200&height=200&seq=creator-avatar-04&orientation=squarish',
    followers: '280万',
    category: '科技数码',
    description: '最新数码产品测评，实用科技技巧分享，让你玩转智能生活。',
  },
];

export const popularVideos = [
  {
    id: 'video-1',
    title: '一分钟学会这个转场技巧，让你的视频质感翻倍',
    cover: 'https://readdy.ai/api/search-image?query=Creative%20video%20editing%20transition%20effect%20demonstration%2C%20minimalist%20dark%20background%20with%20colorful%20light%20trails%2C%20modern%20tech%20aesthetic%2C%20clean%20composition%2C%20professional%20video%20production%20style&width=600&height=800&seq=video-cover-01&orientation=portrait',
    author: '小雨同学',
    views: '128万',
    likes: '45.6万',
    duration: '1:23',
    category: '教程技巧',
  },
  {
    id: 'video-2',
    title: '周末探店：藏在胡同里的宝藏咖啡馆',
    cover: 'https://readdy.ai/api/search-image?query=Cozy%20hidden%20coffee%20shop%20in%20traditional%20alleyway%2C%20warm%20ambient%20lighting%2C%20wooden%20interior%20with%20plants%2C%20aesthetic%20cafe%20photography%2C%20cinematic%20mood%2C%20vertical%20composition&width=600&height=800&seq=video-cover-02&orientation=portrait',
    author: '美食达人Linda',
    views: '89万',
    likes: '32.1万',
    duration: '2:05',
    category: '美食探店',
  },
  {
    id: 'video-3',
    title: '春日穿搭合集：五套百搭又不撞衫的look',
    cover: 'https://readdy.ai/api/search-image?query=Fashionable%20spring%20outfit%20flat%20lay%20collection%2C%20minimalist%20neutral%20background%2C%20trendy%20clothing%20arrangement%2C%20aesthetic%20fashion%20photography%2C%20soft%20natural%20lighting%2C%20clean%20composition&width=600&height=800&seq=video-cover-03&orientation=portrait',
    author: '潮流阿杰',
    views: '210万',
    likes: '67.8万',
    duration: '1:45',
    category: '潮流穿搭',
  },
  {
    id: 'video-4',
    title: '2026年最值得入手的五款真无线耳机横评',
    cover: 'https://readdy.ai/api/search-image?query=Premium%20wireless%20earbuds%20product%20photography%20on%20minimalist%20white%20surface%2C%20sleek%20modern%20design%2C%20clean%20studio%20lighting%2C%20technology%20aesthetic%2C%20sharp%20detail%2C%20professional%20product%20shot&width=600&height=800&seq=video-cover-04&orientation=portrait',
    author: '科技小新',
    views: '156万',
    likes: '52.3万',
    duration: '3:12',
    category: '科技数码',
  },
];